export default "__VITE_ASSET__BgWfPKKv__"